"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 8px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding-left: 23px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 1em;\n  font-weight: 500;\n  position: relative;\n  border: 1px solid #fbcfcd;\n  color: #b20b04;\n  background-color: #fde7e6;\n  padding: 7px;\n  width: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ErrorLabel = _styledComponents.default.label(_templateObject());

var ValidationBox = _styledComponents.default.span(_templateObject2());

var ValidationText = _styledComponents.default.span(_templateObject3());

var ValidationGlyph = _styledComponents.default.span(_templateObject4());

var ValidationError = /*#__PURE__*/function (_React$Component) {
  _inherits(ValidationError, _React$Component);

  function ValidationError() {
    _classCallCheck(this, ValidationError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).apply(this, arguments));
  }

  _createClass(ValidationError, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          forId = _this$props.forId,
          otherAttributes = _objectWithoutProperties(_this$props, ["children", "forId"]);

      return _react.default.createElement(ErrorLabel, {
        role: "alert",
        "aria-atomic": "true",
        htmlFor: forId,
        className: 'hw-validation-label'
      }, _react.default.createElement(ValidationBox, _extends({
        className: 'hw-validation-box'
      }, otherAttributes), _react.default.createElement(ValidationGlyph, {
        className: 'hw-validation-glyph'
      }, _react.default.createElement("svg", {
        role: "presentation",
        focusable: "false",
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: "#950803",
        strokeWidth: "0",
        d: "m15.34324,12.81328l-4.8294,-4.82941l4.82853,-4.82941l-2.48229,-2.48405l-4.8294,4.82941l-4.8294,-4.82941l-2.48229,2.48405l4.82853,4.82941l-4.8294,4.82941l2.48405,2.48317l4.82853,-4.82941l4.82853,4.82941",
        id: "svg_1",
        className: "x_glyph",
        stroke: "#000"
      })))), _react.default.createElement(ValidationText, {
        className: 'hw-validation-text'
      }, children)));
    }
  }]);

  return ValidationError;
}(_react.default.Component);

ValidationError.propTypes = {
  children: _propTypes.default.node.isRequired,
  forId: _propTypes.default.string
};

var _default = (0, _styledComponents.withTheme)(ValidationError);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/ValidationError/index.js